export const promiseChunks = async <T>(fns: (() => Promise<T>)[], chunkSize: number): Promise<T[]> => {
  const chunks: T[] = [];
  for (let i = 0; i < fns.length; i += chunkSize) {

    const chunk = fns.slice(i, i + chunkSize);

    const result = await Promise.all(chunk.map(async (fn) => {
        return fn();
    }));

    chunks.push(...result);
  }
  
  return chunks;
};